import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiInstance } from '../../axiosApi';

const initialState = {};

export const crmsOptionGet = createAsyncThunk('report/crms', async () => {
  return await apiInstance.get('/crms');
});

export const processOptionGet = createAsyncThunk('report/crm-process', async (params) => {
  return await apiInstance.get('/process', { params });
});

export const processAllOptionGet = createAsyncThunk('report/crm-process', async () => {
  return await apiInstance.get('/process');
});

export const processOptionGetByFlag = createAsyncThunk('report/crm-process', async (params) => {
  return await apiInstance.get('/process', { params });
});

export const dailyReportGet = createAsyncThunk('report/daily', async (params) => {
  return await apiInstance.get('/cdrs_report/daily', { params });
});

export const dumpReportGet = createAsyncThunk('report/call_details', async (params) => {
  return await apiInstance.get('/cdrs_report/call_details', { params });
});

export const didDailyReportGet = createAsyncThunk('report/did_daily', async (params) => {
  return await apiInstance.get('/cdrs_report/did_daily', { params });
});

export const didDumpReportGet = createAsyncThunk('report/did_call_details', async (params) => {
  return await apiInstance.get('/cdrs_report/did_call_details', { params });
});

export const dtmfReportGet = createAsyncThunk('report/dtmfreport', async (params) => {
  return await apiInstance.get('/dtmfreport', { params });
});

export const missedCallReportGet = createAsyncThunk('report/missed-call-report', async (params) => {
  return await apiInstance.get('/missed-call-report', { params });
});

export const missedCallReportExport = createAsyncThunk(
  'report/missed-call-report/download',
  async (params) => {
    return await apiInstance.get('/missed-call-report/download', { params, responseType: 'blob' });
  }
);

// 360 view of a destination number: every call from call_history + call_history_archive.
// Omit page/limit to let the API return all records.
export const threeSixtyReportGet = createAsyncThunk('report/360-report', async (params) => {
  return await apiInstance.get('/360-report', { params });
});

export const threeSixtyReportExport = createAsyncThunk(
  'report/360-report/download',
  async ({ onDownloadProgress, ...params }) => {
    return await apiInstance.get('/360-report/download', {
      params,
      responseType: 'blob',
      onDownloadProgress
    });
  }
);

// Full details of one call, looked up by the uuid each /360-report row carries.
export const threeSixtyReportDetailsGet = createAsyncThunk(
  'report/360-report/details',
  async (params) => {
    return await apiInstance.get('/360-report/details', { params });
  }
);

export const performanceReportGet = createAsyncThunk(
  'report/performance-report',
  async (params) => {
    return await apiInstance.get('/performance-report', { params });
  }
);

export const performanceReportExport = createAsyncThunk(
  'report/performance-report-export',
  async (params) => {
    return await apiInstance.get('/performance-report/download', { params, responseType: 'blob' });
  }
);

export const performanceDetailsReportExport = createAsyncThunk(
  'report/performance-report/details-report-download',
  async (params) => {
    return await apiInstance.get('/performance-report/details-report-download', {
      params,
      responseType: 'blob'
    });
  }
);

export const performanceDetailsReport = createAsyncThunk(
  'report/performance-report/details-report',
  async (params) => {
    return await apiInstance.get('/performance-report/details-report', {
      params
    });
  }
);

export const performanceDispositionReportGet = createAsyncThunk(
  'report/agent-disposition-report',
  async (params) => {
    return await apiInstance.get('/agent-disposition-report', { params });
  }
);

export const performanceDispositionReportExport = createAsyncThunk(
  'report/agent-disposition-report-export',
  async (params) => {
    return await apiInstance.get('/agent-disposition-report/download', {
      params,
      responseType: 'blob'
    });
  }
);

export const performanceDispositionDetailsReportExport = createAsyncThunk(
  'report/agent-disposition-report/details-report-download',
  async (params) => {
    return await apiInstance.get('/agent-disposition-report/details-report-download', {
      params,
      responseType: 'blob'
    });
  }
);

export const agentDetailsDispositionReportGet = createAsyncThunk(
  'report/agent-disposition-report/agent-details-disposition-report',
  async (params) => {
    return await apiInstance.get('/agent-disposition-report/agent-details-disposition-report', {
      params
    });
  }
);

export const agentDetailsDispositionReportExport = createAsyncThunk(
  'report/agent-disposition-report/agent-details-disposition-download',
  async (params) => {
    return await apiInstance.get('/agent-disposition-report/agent-details-disposition-download', {
      params,
      responseType: 'blob'
    });
  }
);

export const userOptionGetByProcess = createAsyncThunk(
  'report/performance-report/process-wise-user',
  async (params) => {
    return await apiInstance.get('/performance-report/process-wise-user', { params });
  }
);

export const recordingReportGet = createAsyncThunk('report/recording-report', async (params) => {
  return await apiInstance.get('/recording-report', { params });
});

export const recordingReportDownload = createAsyncThunk(
  'report/recording-report/zip-download',
  async (params) => {
    return await apiInstance.get('/recording-report/zip-download', {
      params,
      responseType: 'blob'
    });
  }
);

export const bothLegsReportGet = createAsyncThunk('report/both-legs-report', async (params) => {
  return await apiInstance.get('/both-legs-report/', { params });
});

export const callConnectivityReportGet = createAsyncThunk(
  'report/calling-report',
  async (params) => {
    return await apiInstance.get('/calling-report', { params });
  }
);

export const getProcessWiseListsOptions = createAsyncThunk(
  'report/dtmfreport/process-wise-lists',
  async (params) => {
    return await apiInstance.get('/dtmfreport/process-wise-lists', { params });
  }
);

export const getListsByProcess = createAsyncThunk('report/lists/by-process', async (params) => {
  return await apiInstance.get('/lists/by-process', { params });
});

export const downloadCallConnectivityReport = createAsyncThunk(
  'report/calling-report/download',
  async ({ onDownloadProgress, ...params }) => {
    return await apiInstance.get('/calling-report/download', {
      params,
      responseType: 'blob',
      onDownloadProgress
    });
  }
);

// The endpoint really is spelled "dailer" on the backend.
export const dialerCallConnectivityReportGet = createAsyncThunk(
  'report/dailer-calling-report',
  async (params) => {
    return await apiInstance.get('/dailer-calling-report', { params });
  }
);

export const downloadDialerCallConnectivityReport = createAsyncThunk(
  'report/dailer-calling-report/download',
  async ({ onDownloadProgress, ...params }) => {
    return await apiInstance.get('/dailer-calling-report/download', {
      params,
      responseType: 'blob',
      onDownloadProgress
    });
  }
);

export const downloadDtmfReport = createAsyncThunk('report/dtmfreport/download', async (params) => {
  return await apiInstance.get('/dtmfreport/download', { params, responseType: 'blob' });
});

export const archiveOptionsGet = createAsyncThunk('report/archive-table-list/', async (params) => {
  return await apiInstance.get('/archive-table-list/', { params });
});

export const followUpReportGet = createAsyncThunk(
  'report/follow-up/followUp-report',
  async (params) => {
    return await apiInstance.get('/follow-up/followUp-report', { params });
  }
);

export const missedFollowUpGet = createAsyncThunk(
  'report/follow-up/follow-up-info',
  async (params) => {
    return await apiInstance.get('/follow-up/follow-up-info', { params });
  }
);

export const leadRetriesReportGet = createAsyncThunk('report/lead-retries-report', async (params) => {
  return await apiInstance.get('/lead-retries-report/', { params });
});

export const leadRetriesReportDetailsGet = createAsyncThunk(
  'report/lead-retries-report/details',
  async (params) => {
    return await apiInstance.get('/lead-retries-report/details', { params });
  }
);

export const callLogsGet = createAsyncThunk('report/call-logs', async (params) => {
  return await apiInstance.get('/call-logs', { params });
});

export const callLogDetailsGetById = createAsyncThunk(
  'configuration/call-logs-id',
  async (call_log_id) => {
    return await apiInstance.get(`/call-logs/${call_log_id}`);
  }
);

export const callexCallLogsGet = createAsyncThunk('report/callex-call-logs', async (params) => {
  return await apiInstance.get('/callex-call/calls/list', { params });
});

export const botCreditReportGet = createAsyncThunk('report/bot-credit-report', async (params) => {
  return await apiInstance.get('/bot-credit-report/', { params });
});

export const botRecordingReportGet = createAsyncThunk(
  'report/bot-recording-report',
  async (params) => {
    return await apiInstance.get('/bot-recording-report/report', { params });
  }
);

export const botArchiveListGet = createAsyncThunk('report/bot-archive-list', async () => {
  return await apiInstance.get('/bot-archive/');
});

export const botCdrsReportGet = createAsyncThunk('report/bot-cdrs-report', async (params) => {
  return await apiInstance.get('/bot-cdrs/report', { params });
});

// Same route as the grid; export=csv makes it return every matching row as a CSV file
// (page/limit are ignored).
export const botCdrsReportExport = createAsyncThunk(
  'report/bot-cdrs-report/export',
  async ({ onDownloadProgress, ...params }) => {
    return await apiInstance.get('/bot-cdrs/report', {
      params: { ...params, export: 'csv' },
      responseType: 'blob',
      onDownloadProgress
    });
  }
);

export const botChatReportGet = createAsyncThunk('report/bot-chat-report', async (params) => {
  return await apiInstance.get('/bot-chat-report', { params });
});

export const botChatReportExport = createAsyncThunk(
  'report/bot-chat-report/export',
  async ({ onDownloadProgress, ...params }) => {
    return await apiInstance.get('/bot-chat-report/export', {
      params,
      responseType: 'blob',
      onDownloadProgress
    });
  }
);

export const botChatReportDetailsGet = createAsyncThunk(
  'report/bot-chat-report/details',
  async (id) => {
    return await apiInstance.get(`/bot-chat-report/${id}`);
  }
);

export const botCdrsTranscribeGet = createAsyncThunk(
  'report/bot-cdrs-transcribe',
  async ({ sessionId, archiveId } = {}) => {
    return await apiInstance.get(`/bot-cdrs/transcribe/${sessionId}`, {
      params: archiveId ? { archiveId } : undefined
    });
  }
);

export const botCdrsSentimentAnalyse = createAsyncThunk(
  'report/bot-cdrs-sentiment',
  async (sessionId) => {
    return await apiInstance.get(`/bot-cdrs/sentiment-analyse/${sessionId}`);
  }
);

// The download endpoint is auth-protected, so fetch the recording as a blob via the
// authenticated client (the Bearer header can't ride on an <audio>/<a> URL).
export const botCdrsDownloadRecording = createAsyncThunk(
  'report/bot-cdrs-download',
  async ({ filename, onDownloadProgress } = {}) => {
    return await apiInstance.get('/bot-cdrs/download', {
      params: { filename },
      responseType: 'blob',
      onDownloadProgress
    });
  }
);

export const callexCallDetailsGet = createAsyncThunk('report/callex-call-details', async (id) => {
  return await apiInstance.get(`/callex-call/${id}`);
});

export const callexCallTranscriptGet = createAsyncThunk(
  'report/callex-call-transcript',
  async (id) => {
    return await apiInstance.get(`/callex-call/${id}/transcript`);
  }
);

export const followUpGetById = createAsyncThunk('report/follow-up/get-by-id', async (id) => {
  return await apiInstance.get(`/follow-up/${id}`);
});

export const followUpUpdate = createAsyncThunk(
  'report/follow-up/followUp-update',
  async (payload) => {
    const { id, ...rest } = payload;
    return await apiInstance.put(`/follow-up/edit-follow-up/${id}`, rest);
  }
);

const dailyReportSlice = createSlice({
  name: 'dailyReport',
  initialState,
  reducers: {
    clearDailyReportSlice: () => initialState
  },
  extraReducers: (builder) => {}
});

export default dailyReportSlice.reducer;
export const { clearDailyReportSlice } = dailyReportSlice.actions;
